import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { SpecialTool, SpecialToolType } from '../business-entities/special-tool-model';
import { SpecialToolDataService } from '../data-services/special-tool-data.service';

@Injectable({
    providedIn: 'root'
})

export class SpecialToolBusinessService {
    constructor(private service: SpecialToolDataService) {
    }
    SpecialToolId:number
    specialToolList: SpecialTool[];
    specialTool: SpecialTool;
    async getSpecialToolList(vehicalObj:any): Promise<SpecialTool[]> {
        await this.service
            .getSpecialToolList(vehicalObj)
            .then(
                (res: GenericResponse<Array<SpecialTool>>) => {
                    this.specialToolList = res.responseObject;
                }
            );
        return this.specialToolList;
    }
    deleteSpecialTool(id: number): Promise<any> {
        return this.service.deleteSpecialTool(id);
    }

    async getSpecialToolById(specialToolId: number) {
        return this.service.getSpecialToolById(specialToolId);
    }

    async addEditSpecialTool(model:any):Promise<any>{
        return this.service.addEditSpecialTool(model);
    }
    async getAllSpecialToolTypes(): Promise<GenericResponse<Array<SpecialToolType>>> {
      return this.service.getAllSpecialToolTypes();
    }

}
